(() => {
  let client;
  (self.PREFERRED_SOURCE = self.PREFERRED_SOURCE || []).push((preferredSource) => {
    try {
      preferredSource.init({ theme: 'dark', lang: 'en' });
      client = preferredSource;
    } catch (_) {}
  });

  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      () => {}
    );
  }

  function trackClick(link) {
    try {
      const shopify = window.Shopify;
      const placement = link.dataset.placement;
      if (!['footer', 'article_end'].includes(placement) ||
          shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true ||
          typeof shopify?.analytics?.publish !== 'function') return;
      const published = shopify.analytics.publish('forest_origins:preferred_source_click', {
        source_domain: 'forestorigins.com',
        page_path: window.location.pathname,
        placement
      });
      if (published && typeof published.catch === 'function') published.catch(() => {});
    } catch (_) {}
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-fo-preferred-source]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    trackClick(link);
    if (!client || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    try {
      client.addPreferredSource();
    } catch (_) {
      window.location.assign(link.href);
    }
  });
})();

